enum SortOrder {
    //Values must be same as in Business\Energipresentation\Enums\SortOrderEnum.cs
    //None = 0 // we don't need to handle this, it'd be null instead.
    Ascending = 1,
    Descending
};

export default SortOrder;